import { Button, Dialog, DialogBody, DialogFooter, Intent } from '@blueprintjs/core'
import * as React from 'react'
import Client from '../../../../client'
import Errors from '../../../../components/Errors'
import { DialogProps, DialogState } from './Types'
import { showSuccess } from '../../../../Toast'

class RecycleDialog extends React.Component<DialogProps, DialogState> {
  constructor(props) {
    super(props)
    this.state = {
      error: null,
      loading: false
    }
  }

  onRecycle = async () => {
    this.setState({ loading: true })
    try {
      await Client.recycleProduct(this.props.productId, true)
      this.setState({ loading: false })
      this.props.onComplete()
      showSuccess('Product Recycled!')
    } catch (error) {
      this.setState({ loading: false, error: error.response.data })
    }
  }

  onClose = e => {
    this.setState({ error: null }, () => this.props.onClose(e))
  }

  render() {
    const { error, loading } = this.state

    return (
      <Dialog title="Recycle Product" isOpen={!!this.props.productId} onClose={e => this.onClose(e)}>
        <DialogBody>
          <Errors error={error} />
          <div>
            <ul>
              <li>This will recycle your product</li>
              <li>You will only be able to see the product in the Recycled tab.</li>
              <li>This product&apos;s listings will still be visible in the Listing Manager</li>
            </ul>
          </div>
        </DialogBody>
        <DialogFooter
          actions={
            <>
              <Button intent={Intent.NONE} onClick={e => this.onClose(e)}>
                Cancel
              </Button>
              <Button loading={loading} intent={Intent.PRIMARY} onClick={this.onRecycle}>
                Recycle
              </Button>
            </>
          }
        />
      </Dialog>
    )
  }
}

export default RecycleDialog
